const carousels = async function () {
    const bigCardCarousel = [...document.querySelectorAll(".big-card-carousel")];
    const bannerCarousel = [...document.querySelectorAll(".banner-carousel")];
    const contentImageCarousel = [...document.querySelectorAll(".content-image-carousel")];
    const teamCarousel = [...document.querySelectorAll(".team-carousel")];
    
    if (bigCardCarousel || bannerCarousel || contentImageCarousel || teamCarousel) {
        const Swiper = await (await import("swiper/bundle")).default;

        if (bigCardCarousel) {
            bigCardCarousel.forEach(section => {
                const carousel = new Swiper(section.querySelector(".swiper"), {
                    slidesPerView: 'auto',
                    effect: "coverflow",
                    grabCursor: true,
                    centeredSlides: true,
                    loop: true,
                    speed: 750,
                    slideToClickedSlide: true,
                    coverflowEffect: {
                        rotate: 0,
                        stretch: 134.1, //125
                        depth: 100,
                        modifier: 2.5,
                        slideShadows: false,
                    },
                    navigation: {
                        nextEl: section.querySelector(".swiper-carousel-next-el"),
                        prevEl: section.querySelector(".swiper-carousel-prev-el"),
                    },
                })
            })
        }
        if (bannerCarousel) {
            bannerCarousel.forEach(section => {
                const carousel = new Swiper(section.querySelector(".swiper"), {
                    slidesPerView: '1',
                    spaceBetween : 32,
                    loop: true,
                    speed: 750,
                    autoplay: {
                        delay: 3000, // Set your delay here
                        disableOnInteraction: false, // Important: lets autoplay continue unless stopped manually
                    },
                    navigation: {
                        nextEl: section.querySelector(".swiper-carousel-next-el"),
                        prevEl: section.querySelector(".swiper-carousel-prev-el"),
                    },
            
                })
                // Stop autoplay when user clicks next or prev
                section.querySelector(".swiper-carousel-next-el").addEventListener("click", () => {
                    carousel.autoplay.stop();
                });

                section.querySelector(".swiper-carousel-prev-el").addEventListener("click", () => {
                    carousel.autoplay.stop();
                });
            })
        }
        if (contentImageCarousel) {
            contentImageCarousel.forEach(section => {
                const carousel = new Swiper(section.querySelector(".swiper"), {
                    slidesPerView: '1',
                    spaceBetween : 32,
                    loop: true,
                    speed: 750,
                    autoplay: {
                        delay: 3000, // Set your delay here
                        disableOnInteraction: false, // Important: lets autoplay continue unless stopped manually
                    },
                    navigation: {
                        nextEl: section.querySelector(".swiper-carousel-next-el"),
                        prevEl: section.querySelector(".swiper-carousel-prev-el"),
                    },

                })
            })
        }
        if (teamCarousel) {
            teamCarousel.forEach(section => {
                const carousel = new Swiper(section.querySelector(".swiper"), {
                    slidesPerView: 1.2,
                    spaceBetween : 20,
                    loop: true,
                    speed: 750,
                    autoplay: {
                        delay: 3000, // Set your delay here
                        disableOnInteraction: false, // Important: lets autoplay continue unless stopped manually
                    },
                    breakpoints: {
                    
                        // when window width is >= 480px
                        768: {
                            slidesPerView: 2.1,
                        },
                        // when window width is >= 640px
                        1024: {
                            slidesPerView: 2.8,
                        },
                        1280: {
                            slidesPerView: 4.1,
                        },
                        1444 : {
                            slidesPerView: 4,
                        }
                    },
                    navigation: {
                        nextEl: section.querySelector(".swiper-carousel-next-el"),
                        prevEl: section.querySelector(".swiper-carousel-prev-el"),
                    },
                })
            })
        }
    }
}

export const init = carousels;